if (!customElements.get('variant-name')) {
  class VariantName extends HTMLElement {
    constructor () {
      super()
      this.handleVariantChange = this.handleVariantChange.bind(this)
    }

    connectedCallback () {
      this.variants = this.querySelectorAll('.variant-name')
      document.addEventListener('variant:change', this.handleVariantChange)
    }

    disconnectedCallback () {
      document.removeEventListener('variant:change', this.handleVariantChange)
    }

    handleVariantChange (event) {
      const current_variant_id = event.detail.variant.id.toString()
      if (current_variant_id && this.variants) {
        this.variants.forEach(variant => {
          const variant_id = variant.dataset.variantId.toString()
          variant.classList.toggle('hidden', variant_id !== current_variant_id)
        })
      }
    }
  }

  customElements.define('variant-name', VariantName)
}